const es = {
    cuit: "CUIT",
    ImpuestoInterno: "Imp. Interno",
    inicio: "Inicio",
};

const es_AR = {
    cuit: "CUIT",
};

const es_BO = {
    cuit: "NIT",
};

const es_CL = {
    cuit: "RUT",
};

const es_EC = {
    cuit: "RUC",
};

const es_ES = {
    cuit: "NIF",
};

const es_MX = {
    cuit: "RFC",
};

const es_PE = {
    cuit: "RUC",
};
const es_PY = {
    cuit: "RUC",
};

const es_UY = {
    cuit: "RUT",
    ImpuestoInterno: "IMESI",
};

export { es, es_AR, es_BO, es_CL, es_EC, es_ES, es_MX, es_PE, es_PY, es_UY };
